import {
  IAuthUser,
  IAuthUserForm,
  ICreatePasswordForm,
  IForgotPasswordForm,
  IResendEmailVerificationLinkForm,
  ISetUpAccountForm,
  ISignUpForm,
} from 'authOld/types';
import { LocalStorageKeys } from 'coreOld/enums';
import { mapRecordFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { IAddress } from 'coreOld/types';
import {
  getDomainUrl,
  getFormData,
  goTo,
  localStorage,
  objectKeysSnakeCaseToCamelCase,
} from 'coreOld/utils';

const oldSignOutPath = () => `${getDomainUrl()}/auth/index/logout/`;

export const getAuthUser = async (signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get('/auth/user/logged-user', signal);

  return mapRecordFromServer<IAuthUser>(data.user);
};

export const signOut = () => {
  localStorage.remove(LocalStorageKeys.LOGGED_USER);

  goTo(oldSignOutPath());
};

export const signIn = async (data: IAuthUserForm) => {
  const dataToSend = getFormData(data);

  const result = await partfinitiClient.post('/auth/standard/sign-in', dataToSend);

  return objectKeysSnakeCaseToCamelCase(result.data);
};

export const resendEmailVerificationLink = async (data: IResendEmailVerificationLinkForm) => {
  const dataToSend = getFormData(data);

  const result = await partfinitiClient.post(
    '/auth/standard/resend-email-verification-link',
    dataToSend
  );

  return result.data;
};

export const forgotPassword = async (data: IForgotPasswordForm) => {
  const dataToSend = getFormData(data);

  const result = await partfinitiClient.post('/auth/standard/recover-password', dataToSend);

  return result.data;
};

export const createPassword = async (data: ICreatePasswordForm) => {
  const dataToSend = getFormData(data);

  const result = await partfinitiClient.post('/auth/standard/setup-password', dataToSend);

  return result.data;
};

export const signUp = async (data: ISignUpForm) => {
  const dataToSend = getFormData(data);

  const result = await partfinitiClient.post('/auth/standard/sign-up', dataToSend);

  return objectKeysSnakeCaseToCamelCase(result.data);
};

export const getDefaultData = async (signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get('/auth/standard/get-default-user-data', signal);

  return objectKeysSnakeCaseToCamelCase(data);
};

export const setUpAccount = async (data: ISetUpAccountForm) => {
  const dataToSend = getFormData(data);

  const result = await partfinitiClient.post('/auth/standard/setup-info', dataToSend);

  return result.data;
};

export const createLocation = async (data: IAddress) => {
  const dataToSend = getFormData(data);

  const result = await partfinitiClient.post('/auth/standard/setup-location', dataToSend);

  return result.data;
};

export const impersonate = async (data: IAddress) => {
  const dataToSend = getFormData(data);

  const result = await partfinitiClient.post('/auth/index/impersonate', dataToSend);

  return objectKeysSnakeCaseToCamelCase(result.data);
};
